import { message } from 'antd';
import { client } from '../../../actions';
import { userActions } from '../../../actions/user.actions';
import { authHeader } from '../../../helpers/auth-header';
import store from '../../../store';

const createRoom = async (facilityId, formValues) => {
  try {
    const response = await client.post(
      '/RentPlace/rental_house/office',
      {
        ...formValues,
        rentalHouse: {
          id: +facilityId,
        },
        description: {
          description: formValues.description,
        },
      },
      { headers: authHeader() }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      store.dispatch(userActions.logout());
      return;
    }
    console.error(error);
    message.error('При создании помещения произошла ошибка');
  }
};

export default createRoom;
